import { render, staticRenderFns } from "./BsListTileSubtitle.vue?vue&type=template&id=4f18862c&scoped=true&"
import script from "./BsListTileSubtitle.vue?vue&type=script&lang=js&"
export * from "./BsListTileSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f18862c",
  null
  
)

export default component.exports